import type { AIActivity } from '../types/contracts';
import { shortTime } from '../lib/format';

const KIND_ICON: Record<AIActivity['kind'], { icon: string; cls: string }> = {
  message: { icon: 'ri-chat-3-line', cls: 'bg-sky-50 text-sky-600' },
  ai_action: { icon: 'ri-robot-2-line', cls: 'bg-teal-50 text-teal-700' },
  system: { icon: 'ri-settings-4-line', cls: 'bg-gray-100 text-gray-500' },
  scheduled: { icon: 'ri-calendar-line', cls: 'bg-violet-50 text-violet-600' },
};

export function ActivityTimeline({ items }: { items: AIActivity[] }) {
  const sorted = [...items].sort((a, b) => +new Date(a.at) - +new Date(b.at));
  return (
    <ol className="relative border-s border-gray-200 ms-2 space-y-4">
      {sorted.map((a) => {
        const k = KIND_ICON[a.kind];
        return (
          <li key={a.id} className="ms-5 relative">
            <span className={`absolute -start-[27px] top-0 w-6 h-6 rounded-full flex items-center justify-center text-xs ${k.cls}`}>
              <i className={k.icon} />
            </span>
            <p className="text-[11px] text-gray-400">{shortTime(a.at)}</p>
            <p className="text-xs font-semibold text-gray-800">{a.label}</p>
          </li>
        );
      })}
    </ol>
  );
}
